import { Form as FormAntd, FormInstance } from "antd";
import { PropsWithChildren, useContext, useMemo } from "react";
import { FormDebugger } from "../../components/FormDebuger";
import { createFormContext } from "../../context";

type PropsFormProvider = {
  Form: typeof FormAntd;
  initialValues?: any;
  form: FormInstance;
  onFinish: (values: any) => void;
  onFinishFailed: (values: any) => void;
  debug?: boolean;
};

export const FormContext = createFormContext({
  Form: FormAntd,
  form: undefined,
  onFinish: () => {},
  onFinishFailed: () => {},
  initialValues: undefined,
});

export const FormProvider = ({
  Form,
  form,
  initialValues,
  onFinish,
  onFinishFailed,
  children,
  debug,
}: PropsWithChildren & PropsFormProvider) => {
  const init = useMemo(() => {
    return initialValues;
  }, [initialValues]);
  return (
    <FormContext.Provider
      value={{
        Form,
        form,
        onFinish,
        onFinishFailed,
        initialValues: init,
        debug,
      }}
    >
      <Form
        initialValues={init}
        form={form}
        className="my-[50px] flex flex-col gap-[20px]"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        {children}
        {process.env.REACT_APP_MODE === "dev" && (
          <FormDebugger Form={Form} form={form} />
        )}
      </Form>
    </FormContext.Provider>
  );
};

export const useMLForm = () => useContext(FormContext);
